import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled, createTheme } from "@mui/material/styles";
import { sanitizeRichText } from "../utils/sanitizeHtml";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import Button from "@mui/material/Button";
import LayersIcon from "@mui/icons-material/Layers";
import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import LogoutIcon from "@mui/icons-material/Logout";
import { PageContainer } from "@toolpad/core/PageContainer";
import Grid from "@mui/material/Grid";
import { addProductToStore, deleteProductById, getAllCategories, getAllProductsByPage, uploadImageToMedia, updateProductById, getProductBySlug } from "../Api";
import { BsGrid3X3GapFill } from "react-icons/bs";
import { HiUsers } from "react-icons/hi2";
import { FaBasketShopping, FaFilePrescription } from "react-icons/fa6";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SearchIcon from '@mui/icons-material/Search';
import Stack from "@mui/material/Stack";
import { FaFileAlt, FaLocationArrow } from "react-icons/fa";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import CsvProductUploader from "../components/CsvProductUploader";
import { BiSolidCoupon } from "react-icons/bi";

const NAVIGATION = [
  {
    kind: 'header',
    title: 'Main items',
  },
  {
    segment: 'dashboard',
    title: 'Dashboard',
    icon: <DashboardIcon />,
  },
  {
    segment: 'dashboard-products',
    title: 'Products',
    icon: <FaBasketShopping style={{ fontSize: '22px' }} />,
  },
  {
    segment: 'dashboard-users',
    title: 'Users',
    icon: <HiUsers style={{ fontSize: '22px' }} />,
  },
  {
    segment: 'dashboard-categories',
    title: 'Categories',
    icon: <BsGrid3X3GapFill style={{ fontSize: '22px' }} />,
  },
  {
    segment: 'dashboard-orders',
    title: 'Orders',
    icon: <ShoppingCartIcon />,
  },
  {
    segment: 'prescriptions',
    title: 'Prescriptions',
    icon: <FaFilePrescription style={{ fontSize: '20px' }} />,
  },
  {
    segment: 'dashboard-coupons',
    title: 'Coupons',
    icon: <BiSolidCoupon style={{ fontSize: '22px' }} />,
  },
  {
    segment: 'dashboard-content',
    title: 'Content',
    icon: <FaFileAlt style={{ fontSize: '20px' }} />,
  },
  {
    segment: 'dashboard-location',
    title: 'Location',
    icon: <FaLocationArrow />,
  },
  {
    kind: 'divider',
  },
  {
    kind: 'header',
    title: 'Analytics',
  },
  {
    segment: 'reports',
    title: 'Reports',
    icon: <BarChartIcon />,
    children: [
      {
        segment: 'sales',
        title: 'Sales',
        icon: <DescriptionIcon />,
      },
      {
        segment: 'traffic',
        title: 'Traffic',
        icon: <DescriptionIcon />,
      },
    ],
  },
  {
    segment: 'integrations',
    title: 'Integrations',
    icon: <LayersIcon />,
  },
];

const Skeleton = styled("div")(({ theme, height }) => ({
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.shape.borderRadius,
  height,
  content: '" "',
}));

function useDemoRouter(initialPath) {
  const [pathname, setPathname] = React.useState(initialPath);
  const navigate = useNavigate();

  const router = React.useMemo(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => {
        setPathname(String(path));
        navigate(path);
      },
    };
  }, [pathname, navigate]);

  return router;
}

const theme = createTheme({
  palette: {
    mode: "light",
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 650,
  overflowY: "scroll",
  bgcolor: "background.paper",
  border: "1px solid transparent",
  borderRadius: 1,
  shadow: 24,
  p: 4,
};

function DshProducts({ onLogout }) {
  const navigate = useNavigate();
  const router = useDemoRouter("/dashboard-products");
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [retriveCateory, setRetriveCateory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage] = useState(50);
  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editProductId, setEditProductId] = useState(null);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);

  // For Add/Edit Product
  const [pName, setPName] = useState("");
  const [pType, setPType] = useState("");
  const [orderMethod, setOrderMethod] = useState("");
  const [pPrice, setPPrice] = useState("");
  const [pSalePrice, setPSalePrice] = useState("");
  const [pDescription, setPDescription] = useState("");
  const [pCategory, setPCategory] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [pOnSale, setPOnSale] = useState(false);
  const [pStockQuantity, setPStockQuantity] = useState("");
  const [pStockStatus, setPStockStatus] = useState("instock");
  const [pBackordersAllowed, setPBackordersAllowed] = useState(false);
  const [pWeight, setPWeight] = useState("");
  const [pLength, setPLength] = useState("");
  const [pWidth, setPWidth] = useState("");
  const [pHeight, setPHeight] = useState("");
  const [pDateOnSaleFrom, setPDateOnSaleFrom] = useState("");
  const [pDateOnSaleTo, setPDateOnSaleTo] = useState("");

  const validatePrice = (price) => {
    if (price === "") return true;
    const num = parseFloat(price);
    return !isNaN(num) && num >= 0;
  };

  const validateDate = (date) => {
    if (!date) return true;
    const dateObj = new Date(date);
    return !isNaN(dateObj.getTime());
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllCategories();
        setRetriveCateory(Array.isArray(response.data) ? response.data : []);
        setTotalPages(response.totalPages || 1);
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast.error("Failed to fetch categories: " + (error.message || "Unknown error"));
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await getAllProductsByPage(currentPage, perPage);
        setProducts(Array.isArray(response.data) ? response.data : []);
        console.log(response);

        setTotalPages(response.totalPages || 1);
      } catch (error) {
        console.error("Error fetching products:", error);
        setProducts([]);
        setTotalPages(1);
        toast.error("Failed to fetch products: " + (error.message || "Unknown error"));
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [currentPage, perPage]);

  useEffect(() => {
    setFilteredProducts(products);
  }, [products]);

  const handleLogoutClick = () => {
    setOpenLogoutDialog(true);
  };

  const handleLogoutConfirm = () => {
    setOpenLogoutDialog(false);
    onLogout();
    navigate("/");
  };

  const handleLogoutCancel = () => {
    setOpenLogoutDialog(false);
  };

  const branding = {
    logo: (
      <div className="header-logo">
        <img onClick={() => navigate('/')} src={require('../images/logo.png')} alt="" style={{ height: '52px', width: '60px' }} />
      </div>
    ),
    title: "",
  };

  const deleteProduct = async (productId) => {
    if (window.confirm("Are you sure you want to delete the product?")) {
      setLoading(true);
      try {
        await deleteProductById(productId);
        toast.success("Product deleted successfully");
        const response = await getAllProductsByPage(currentPage, perPage);
        setProducts(Array.isArray(response.data) ? response.data : []);
        setTotalPages(response.totalPages || 1);
      } catch (error) {
        console.error("Error deleting product:", error);
        toast.error("Failed to delete product: " + (error.message || "Unknown error"));
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSearch = async () => {
    setLoading(true)
    try {
      const response = await getProductBySlug(searchTerm)
      setFilteredProducts(response ? response : [])
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  };

  const handleOpen = (product = null) => {
    if (product) {
      setIsEditMode(true);
      setEditProductId(product.id);
      setPName(product.name);
      setPType(product.type);
      setOrderMethod(product.purchase_note || "");
      setPPrice(product.regular_price || product.price || "");
      setPSalePrice(product.sale_price || "");
      setPDescription(product.description || "");
      setPCategory(product.categories.map((cat) => cat.id));
      setSelectedImages(
        product.images.map((img) => ({ id: img.id, src: img.src }))
      );
      setPOnSale(product.on_sale || false);
      setPStockQuantity(product.stock_quantity || "");
      setPStockStatus(product.stock_status || "instock");
      setPBackordersAllowed(product.backorders_allowed || false);
      setPWeight(product.weight || "");
      setPLength(product.dimensions?.length || "");
      setPWidth(product.dimensions?.width || "");
      setPHeight(product.dimensions?.height || "");
      setPDateOnSaleFrom(product.date_on_sale_from || "");
      setPDateOnSaleTo(product.date_on_sale_to || "");
    } else {
      setIsEditMode(false);
      setEditProductId(null);
      setPName("");
      setPType("");
      setOrderMethod("");
      setPPrice("");
      setPSalePrice("");
      setPDescription("");
      setPCategory([]);
      setSelectedImages([]);
      setPOnSale(false);
      setPStockQuantity("");
      setPStockStatus("instock");
      setPBackordersAllowed(false);
      setPWeight("");
      setPLength("");
      setPWidth("");
      setPHeight("");
      setPDateOnSaleFrom("");
      setPDateOnSaleTo("");
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
    setEditProductId(null);
    setPName("");
    setPType("");
    setOrderMethod("");
    setPPrice("");
    setPSalePrice("");
    setPDescription("");
    setPCategory([]);
    setSelectedImages([]);
    setPOnSale(false);
    setPStockQuantity("");
    setPStockStatus("instock");
    setPBackordersAllowed(false);
    setPWeight("");
    setPLength("");
    setPWidth("");
    setPHeight("");
    setPDateOnSaleFrom("");
    setPDateOnSaleTo("");
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleCheckboxChange = (value) => {
    setPCategory((prev) =>
      prev.includes(value) ? prev.filter((id) => id !== value) : [...prev, value]
    );
  };

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];

    const convertToJpeg = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const MAX_WIDTH = 1000;
            const scaleSize = MAX_WIDTH / img.width;
            canvas.width = MAX_WIDTH;
            canvas.height = img.height * scaleSize;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            canvas.toBlob(
              (blob) => {
                if (blob) {
                  const convertedFile = new File(
                    [blob],
                    file.name.replace(/\.\w+$/, ".jpg"),
                    { type: "image/jpeg", lastModified: Date.now() }
                  );
                  resolve({ file: convertedFile, preview: URL.createObjectURL(convertedFile) });
                } else {
                  reject(new Error("Canvas conversion failed"));
                }
              },
              "image/jpeg",
              0.8
            );
          };
          img.onerror = () => reject(new Error(`Invalid image data for ${file.name}`));
          img.src = event.target.result;
        };
        reader.onerror = () => reject(new Error(`Failed to read file ${file.name}`));
        reader.readAsDataURL(file);
      });
    };

    const processedImages = await Promise.all(
      files.map(async (file) => {
        try {
          const mimeType = file.type;
          if (!allowedTypes.includes(mimeType)) {
            console.warn(`File ${file.name} has unsupported MIME type: ${mimeType}. Converting to JPEG.`);
            const converted = await convertToJpeg(file);
            toast.info(`Converted ${file.name} to JPEG`);
            return converted;
          }
          const isValidImage = await new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = URL.createObjectURL(file);
          });
          if (!isValidImage) {
            throw new Error(`File ${file.name} is not a valid image`);
          }
          if (file.size > maxSize) {
            console.warn(`File ${file.name} exceeds size limit. Converting to JPEG.`);
            const converted = await convertToJpeg(file);
            toast.info(`Converted ${file.name} to JPEG due to size`);
            return converted;
          }
          return { file, preview: URL.createObjectURL(file) };
        } catch (err) {
          console.error(`Error processing ${file.name}:`, err);
          toast.error(`Could not process ${file.name}: ${err.message}`);
          return null;
        }
      })
    );

    const validImages = processedImages.filter((item) => item !== null);
    if (validImages.length === 0) {
      toast.error("No valid images selected");
      return;
    }

    setSelectedImages((prev) => [...prev, ...validImages]);
  };

  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
  };

  async function handleProductSubmit(e) {
    e.preventDefault();
    if (!pName) {
      toast.error("Product name is required");
      return;
    }
    if (!pPrice || !validatePrice(pPrice)) {
      toast.error("Valid regular price is required (non-negative number)");
      return;
    }
    if (!pType) {
      toast.error("Product type is required");
      return;
    }
    if (pSalePrice && !validatePrice(pSalePrice)) {
      toast.error("Sale price must be a non-negative number");
      return;
    }
    if (pDateOnSaleFrom && !validateDate(pDateOnSaleFrom)) {
      toast.error("Invalid Date on Sale From");
      return;
    }
    if (pDateOnSaleTo && !validateDate(pDateOnSaleTo)) {
      toast.error("Invalid Date on Sale To");
      return;
    }
    if (pDateOnSaleFrom && pDateOnSaleTo && new Date(pDateOnSaleFrom) > new Date(pDateOnSaleTo)) {
      toast.error("Date on Sale From cannot be later than Date on Sale To");
      return;
    }

    setLoading(true);
    try {
      const uploadedImageUrls = await Promise.all(
        selectedImages.map(async (item) => {
          if (item.src) {
            return { id: item.id, src: item.src };
          }
          try {
            const response = await uploadImageToMedia(item.file, "products", item.file.name);
            return { id: response.id, src: response.url };
          } catch (error) {
            console.error(`Failed to upload image ${item.file.name}:`, {
              message: error.message,
              response: error.response?.data,
              status: error.response?.status,
            });
            toast.error(`Failed to upload image ${item.file.name}: ${error.message}`);
            return null;
          }
        })
      ).then((results) => results.filter((url) => url !== null));

      if (selectedImages.length > 0 && uploadedImageUrls.length === 0) {
        toast.error("No images were uploaded successfully. Cannot proceed.");
        setLoading(false);
        return;
      }

      const regularPrice = parseFloat(pPrice).toFixed(2);
      const salePrice = pSalePrice ? parseFloat(pSalePrice).toFixed(2) : "";
      const isOnSale = !!pSalePrice && parseFloat(pSalePrice) < parseFloat(pPrice);

      const formattedCategories = pCategory.map((id) => ({ id: Number(id) }));
      const data = {
        name: pName,
        type: pType || "simple",
        purchase_note: orderMethod || "prescription",
        regular_price: regularPrice,
        sale_price: salePrice,
        description: pDescription,
        short_description: "",
        categories: formattedCategories,
        images: uploadedImageUrls,
        on_sale: isOnSale,
        stock_quantity: pStockQuantity ? Number(pStockQuantity) : null,
        stock_status: pStockStatus,
        backorders_allowed: pBackordersAllowed,
        weight: pWeight,
        dimensions: {
          length: pLength,
          width: pWidth,
          height: pHeight,
        },
        date_on_sale_from: pDateOnSaleFrom || null,
        date_on_sale_to: pDateOnSaleTo || null,
      };

      if (isEditMode) {
        const response = await updateProductById(editProductId, data);
        console.log('Update API Response:', response);
        toast.success("Product updated successfully");
      } else {
        const response = await addProductToStore(data);
        console.log('Add API Response:', response);
        toast.success("Product added successfully");
      }

      const response = await getAllProductsByPage(currentPage, perPage);
      setProducts(Array.isArray(response.data) ? response.data : []);
      setTotalPages(response.totalPages || 1);
      handleClose();
    } catch (error) {
      console.error(`Error ${isEditMode ? "updating" : "adding"} product:`, {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        request: error.config,
      });
      toast.error(
        `Failed to ${isEditMode ? "update" : "add"} product: ${error.message || 'Unknown error'}`
      );
    } finally {
      setLoading(false);
    }
  }

  const ToolbarActions = () => (
    <Button
      variant="outlined"
      startIcon={<LogoutIcon />}
      onClick={handleLogoutClick}
      sx={{ marginRight: 2 }}
      style={{ background: "#0165AB", color: "#fff" }}
    >
      Logout
    </Button>
  );

  return (
    <AppProvider navigation={NAVIGATION} router={router} theme={theme} branding={branding}>
      <DashboardLayout
        slots={{
          toolbarActions: ToolbarActions,
        }}
      >
        <PageContainer>
          {loading ? (
            <Grid container spacing={1}>
              <Grid size={10}>
                <Skeleton height={35} />
              </Grid>
              <Grid size={2}>
                <Skeleton height={35} />
              </Grid>
              {[...Array(10)].map((_, index) => (
                <Grid size={3} width={200} key={index}>
                  <Skeleton height={330} />
                </Grid>
              ))}
            </Grid>
          ) : (
            <section className="admin-dashboard">
              <Grid container spacing={1}>
                <Grid size={4}>
                  <div style={{ height: "40px" }}>
                    <TextField
                      id="search-field"
                      type="search"
                      style={{ width: "100%" }}
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton aria-label="search" onClick={handleSearch}>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                  </div>
                </Grid>
                <Grid size={4}></Grid>
                <Grid size={2}>
                  <CsvProductUploader />
                </Grid>
                <Grid size={2}>
                  <button
                    style={{
                      height: "35px",
                      width: "100%",
                      border: "1px solid transparent",
                      background: "#0165AB",
                      color: "#fff",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleOpen()}
                  >
                    ADD PRODUCT
                  </button>

                  <Modal
                    open={open}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <Typography
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        {isEditMode ? "Update Product" : "Add Product"}
                      </Typography>
                      <Box sx={{ mt: 2 }}>
                        <form action="" className="product-form">
                          <div className="product-input-group">
                            <label htmlFor="name">Name</label>
                            <br />
                            <input
                              onChange={(e) => setPName(e.target.value)}
                              type="text"
                              name="name"
                              required
                              value={pName}
                            />
                          </div>
                          <div className="product-input-groups">
                            <label htmlFor="type">Type</label>
                            <br />
                            <select
                              onChange={(e) => setPType(e.target.value)}
                              name="type"
                              required
                              value={pType}
                              style={{ height: "30px", width: "100%", padding: "0 10px", marginBottom: "20px" }}
                            >
                              <option value="" disabled>
                                Select Type
                              </option>
                              <option value="simple">Simple</option>
                              <option value="variable">Variable</option>
                              <option value="grouped">Grouped</option>
                              <option value="external">External</option>
                            </select>
                          </div>
                          <div className="product-input-groups">
                            <label htmlFor="order_method">Order Method</label>
                            <br />
                            <select
                              onChange={(e) => setOrderMethod(e.target.value)}
                              name="order_method"
                              required
                              value={orderMethod}
                              style={{ height: "30px", width: "100%", padding: "0 10px", marginBottom: "20px" }}
                            >
                              <option value="" disabled>
                                Select Method
                              </option>
                              <option value="otc">OTC Medicine</option>
                              <option value="prescription">Prescription Medicine</option>
                            </select>
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="regular_price">Regular Price</label>
                            <br />
                            <input
                              onChange={(e) => setPPrice(e.target.value)}
                              type="number"
                              name="regular_price"
                              required
                              value={pPrice}
                              min="0"
                              step="0.01"
                            />
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="sale_price">Sale Price</label>
                            <br />
                            <input
                              onChange={(e) => setPSalePrice(e.target.value)}
                              type="number"
                              name="sale_price"
                              value={pSalePrice}
                              min="0"
                              step="0.01"
                            />
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="on_sale">On Sale</label>
                            <br />
                            <select
                              onChange={(e) => setPOnSale(e.target.value === "true")}
                              name="on_sale"
                              value={pOnSale}
                            >
                              <option value={false}>False</option>
                              <option value={true}>True</option>
                            </select>
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="date_on_sale_from">Date on Sale From</label>
                            <br />
                            <input
                              onChange={(e) => setPDateOnSaleFrom(e.target.value)}
                              type="date"
                              name="date_on_sale_from"
                              value={pDateOnSaleFrom}
                            />
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="date_on_sale_to">Date on Sale To</label>
                            <br />
                            <input
                              onChange={(e) => setPDateOnSaleTo(e.target.value)}
                              type="date"
                              name="date_on_sale_to"
                              value={pDateOnSaleTo}
                            />
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="stock_quantity">Stock Quantity</label>
                            <br />
                            <input
                              onChange={(e) => setPStockQuantity(e.target.value)}
                              type="number"
                              name="stock_quantity"
                              value={pStockQuantity}
                              min="0"
                            />
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="stock_status">Stock Status</label>
                            <br />
                            <select
                              onChange={(e) => setPStockStatus(e.target.value)}
                              name="stock_status"
                              value={pStockStatus}
                            >
                              <option value="instock">In Stock</option>
                              <option value="outofstock">Out of Stock</option>
                            </select>
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="backorders_allowed">Backorders Allowed</label>
                            <br />
                            <select
                              onChange={(e) => setPBackordersAllowed(e.target.value === "true")}
                              name="backorders_allowed"
                              value={pBackordersAllowed}
                            >
                              <option value={false}>False</option>
                              <option value={true}>True</option>
                            </select>
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="weight">Weight</label>
                            <br />
                            <input
                              onChange={(e) => setPWeight(e.target.value)}
                              type="text"
                              name="weight"
                              value={pWeight}
                            />
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="dimensions">Dimensions</label>
                            <br />
                            <div style={{ display: "flex", gap: "10px" }}>
                              <input
                                onChange={(e) => setPLength(e.target.value)}
                                type="text"
                                name="length"
                                placeholder="Length"
                                value={pLength}
                                style={{ width: "33%" }}
                              />
                              <input
                                onChange={(e) => setPWidth(e.target.value)}
                                type="text"
                                name="width"
                                placeholder="Width"
                                value={pWidth}
                                style={{ width: "33%" }}
                              />
                              <input
                                onChange={(e) => setPHeight(e.target.value)}
                                type="text"
                                name="height"
                                placeholder="Height"
                                value={pHeight}
                                style={{ width: "33%" }}
                              />
                            </div>
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="description">Description</label>
                            <br />
                            <textarea
                              onChange={(e) => setPDescription(e.target.value)}
                              style={{ height: "80px", padding: "5px 10px 0" }}
                              name="description"
                              id="description"
                              value={pDescription}
                            ></textarea>
                          </div>
                          <div className="product-input-group">
                            <label htmlFor="categories">Categories</label>
                            <br />
                            <div className="d-grid">
                              {Array.isArray(retriveCateory) && retriveCateory.length > 0 ? (
                                retriveCateory.map((item) => (
                                  <div key={item.id} className="d-flex">
                                    <input
                                      type="checkbox"
                                      value={item.id}
                                      onChange={() => handleCheckboxChange(item.id)}
                                      style={{ width: "fit-content" }}
                                      name="category"
                                      checked={pCategory.includes(item.id)}
                                    />
                                    <span style={{ margin: "3px 0 0 5px" }}>{item.name}</span>
                                  </div>
                                ))
                              ) : (
                                <p>No categories found</p>
                              )}
                            </div>
                          </div>
                          <div className="product-input-group">
                            <div className="d-flex">
                              <label htmlFor="images">Images</label>
                              <input
                                type="file"
                                multiple
                                name="images"
                                id="images"
                                accept="image/jpeg,image/png,image/gif"
                                onChange={handleImageChange}
                              />
                            </div>
                            <small style={{ color: "#666", marginTop: "5px", display: "block" }}>
                              Supported formats: JPEG, PNG, GIF. Maximum file size: 5MB per image.
                            </small>
                            <div
                              className="image-preview"
                              style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}
                            >
                              {selectedImages.length > 0 ? (
                                selectedImages.map((item, index) => (
                                  <div key={index} style={{ position: "relative" }}>
                                    <img
                                      src={item.preview || item.src}
                                      alt={`Selected ${index + 1}`}
                                      style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                    />
                                    <button
                                      style={{
                                        position: "absolute",
                                        top: "0",
                                        right: "0",
                                        background: "red",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => removeImage(index)}
                                    >
                                      X
                                    </button>
                                  </div>
                                ))
                              ) : (
                                <p>No images selected</p>
                              )}
                            </div>
                          </div>
                          <div className="d-flex">
                            <button
                              style={{
                                height: "35px",
                                width: "100px",
                                border: "1px solid transparent",
                                background: "red",
                                color: "#fff",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                              onClick={handleClose}
                            >
                              Cancel
                            </button>
                            <button
                              style={{
                                height: "35px",
                                width: "100px",
                                margin: "0 0 0 20px",
                                border: "1px solid transparent",
                                background: "#0165AB",
                                color: "#fff",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                              onClick={handleProductSubmit}
                            >
                              {isEditMode ? "Update" : "Add"}
                            </button>
                          </div>
                        </form>
                      </Box>
                    </Box>
                  </Modal>
                </Grid>

                <Grid size={12} height={10} />
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((item) => (
                    <Grid size={3} width={200} key={item?.id}>
                      <div style={{ height: "330px", boxShadow: "0 0 3px #000", borderRadius: "5px" }}>
                        <div style={{ height: "150px", width: "200px" }}>
                          <img
                            src={item?.images[0]?.src}
                            style={{ height: "150px", width: "200px", borderRadius: "5px 5px 0 0" }}
                            alt={item.name}
                          />
                        </div>
                        <h4 style={{ textAlign: "center", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>{item.name}</h4>
                        {item.stock_status === "instock" ? (
                          <div style={{ width: "fit-content", margin: "auto" }}>
                            {item.sale_price === "" ? (
                              <span>₹{item.regular_price || item.price}</span>
                            ) : (
                              <>
                                <strike style={{ padding: "4px 0 0", fontSize: "14px" }}>
                                  ₹{item.regular_price || item.price}
                                </strike>
                                <span style={{ marginLeft: "5px", fontSize: "18px" }}>
                                  ₹{item.sale_price}
                                </span>
                              </>
                            )}
                          </div>
                        ) : (
                          <div className="product-out-of-stock">out of stock</div>
                        )}
                        <p
                          style={{ textAlign: "center" }}
                          className="product-card-description"
                          dangerouslySetInnerHTML={{ __html: sanitizeRichText(item?.description) }}
                        ></p>
                        <button
                          style={{
                            width: "180px",
                            height: "fit-content",
                            padding: "8px 0",
                            border: "1px solid transparent",
                            background: "#0165AB",
                            color: "#fff",
                            margin: "5px auto 0",
                            display: "block",
                            borderRadius: "5px",
                            cursor: "pointer",
                            textTransform: "uppercase",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                          onClick={() => handleOpen(item)}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            width: "180px",
                            height: "fit-content",
                            padding: "8px 0",
                            border: "1px solid transparent",
                            background: "#0165AB",
                            color: "#fff",
                            margin: "5px auto 0",
                            display: "block",
                            borderRadius: "5px",
                            cursor: "pointer",
                            textTransform: "uppercase",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                          onClick={() => deleteProduct(item.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </Grid>
                  ))
                ) : (
                  <p>No products found!</p>
                )}
              </Grid>
            </section>
          )}
          <Stack spacing={2} style={{ margin: "3% auto 20px" }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Stack>
        </PageContainer>
      </DashboardLayout>
      <Dialog
        open={openLogoutDialog}
        onClose={handleLogoutCancel}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogoutCancel}>Cancel</Button>
          <Button onClick={handleLogoutConfirm} autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </AppProvider>
  );
}

export default DshProducts;